import React from 'react';
import './Gallery.css';
import sundance from '../../img/sundance.jpg';
import sundance0 from '../../img/sundance0.jpg';
import sundance1 from '../../img/sundance1.jpg';
import sundance2 from '../../img/sundance2.jpg';

class sundanceg extends React.Component {
    state = {
        slides: [sundance, sundance0, sundance1, sundance2],
        image: 1
    }

    galleryControl(n) {
        let t = this.state.image;
        let l = this.state.slides.length;

        if(n + t >= l) {
            t = 0;
        } else if(n + t < 0) {
            t = l-1;
        } else {
            t = t + n;
        }

        this.setState({image: t});
    }

    render() {
        return (
            <div className="gallery">
                <img alt="ss1" src={this.state.slides[this.state.image]} className="gallery__slide"/>
                <div className="gallery__controls">
                    <button className="gallery__button inverted" onClick={() => {this.galleryControl(-1)}}>&#8249; Prev</button>
                    <a href="https://www.outdoorsy.com/rv-rental/franklin_tn/2017_heartland_sundance_90286-listing?ref=bgo7j3"><button className="gallery__button">Book Me</button></a>
                    <button className="gallery__button inverted" onClick={() => {this.galleryControl(1)}}>Next &#8250;</button>
                </div>
                <p className="">Fifth Wheel BUNK-HOUSE 42ft w/ 5 Slide-Outs</p>
                <p className="">Delivery, setup, demo, tear-down, and removal service are included for all rentals of this unit.</p>
                <p className="">This RV comes fully equipped with sheets, blankets, pillows, towels, outdoor camp chairs, and are delivered, set-up, demonstrated, torn-down, and removed. We also handle the dirty laundry after your stay and all sewage dumping and sanitation requirements.</p>
                <p className=""><b>What's included?</b></p>
                <ul className="">
                    <li>TV</li>
                    <li>Large trash-can</li>
                    <li>Dish Strainer</li>
                    <li>Broom</li>
                    <li>Towels</li>
                    <li>Hand Towels</li>
                    <li>Wash Clothes</li>
                    <li>Coffee Maker</li>
                    <li>Grilling Utensil Set</li>
                    <li>Outdoor Camp Chairs</li>
                    <li>Cooking utensils, silver-ware, plates, cups, can openers, wine bottle opener, pots/pans, etc.</li>
                    <li>Bluetooth Stereo System</li>
                    <li>Surround Sound System</li>
                    <li>DVD / CD Player</li>
                </ul>
                <p className=""><b>Sleep Setup:</b></p>
                <ul className="">
                    <li>Front Queen Bed (2 Adults)</li>
                    <li>Fold-out Couch Living Room - Twin Bed (2 Adults)</li>
                    <li>Fold-Down Dinette Table ( 2 Children) </li>
                    <li>Rear-Couch (2 Adults) </li>
                    <li>2 X Bunk-Beds ( 2 Adults or 3 Children)</li>
                </ul>
                <p className="">Cheers and Happy Camping!</p>
            </div>
        );
    }
}

export default sundanceg;